import * as actions from './actions';

const tourStatusModule = {
  namespaced: true,
  actions,
};

export default tourStatusModule;
